module.exports = __webpack_public_path__ + "static/media/ordinary-day.9112e882.png";